// extracted by mini-css-extract-plugin
module.exports = {"holder":"Star_holder__2szcj","dulled":"Star_dulled__28NS6","displayOnly":"Star_displayOnly__2atQP"};